import React, { useState } from "react";
import styles from "./ConfigureColumn.module.css";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
const columnOptions = [
  "Student Name",
  "Program",
  "Status",
  "Source",
  "Primary contact",
  "Next follow up",
  "Assign to",
  "Last follow up",
  "Parent name (1)",
  "contact",
  "Parent name (2)",
  "Parent email (1)",
  "Parent email (2)",
  "created on",
];

const ConfigureColumn = () => {
  const dispatch = useDispatch();
  const [selectedColumns, setSelectedColumns] = useState([
    
  ]);

  const toggleColumn = (col) => {
    setSelectedColumns((prev) =>
      prev.includes(col) ? prev.filter((item) => item !== col) : [...prev, col]
    );
  };

  const handleCancel = () => {
    dispatch(closeModal());
  };

  const handleSave = () => {
    console.log("Selected Columns:", selectedColumns);
    dispatch(closeModal());
  };

  return (
    <div className={styles.modal}>
      <h3 className={styles.heading}>Configure column</h3>
      <div className={styles.content}>
        <div className={styles.grid}>
          {columnOptions.map((col, index) => (
            <label key={index} className={styles.label}>
              <input
                type="checkbox"
                checked={selectedColumns.includes(col)}
                onChange={() => toggleColumn(col)}
              />
              <span
                className={
                  selectedColumns.includes(col)
                    ? styles.selectedText
                    : styles.normalText
                }
              >
                {col}
              </span>
            </label>
          ))}
        </div>

        <div className={styles.buttonContainer}>
          <SaveAndCancel onCancel={handleCancel} onSave={handleSave} />
        </div>
      </div>
    </div>
  );
};

export default ConfigureColumn;
